<template>
  <v-app-bar
    absolute
    app
    color="transparent"
    flat
    height="75"
    style="width: auto"
  >
    <v-btn
      fab
      small
      @click="
        $vuetify.breakpoint.smAndDown
          ? setDrawer(!drawer)
          : $emit('input', !value)
      "
    >
      <v-icon v-if="value">mdi-view-quilt</v-icon>

      <v-icon v-else>mdi-dots-vertical</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down" v-text="$route.name" />

    <v-spacer />

    <!--<v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      class="mb-2"
      style="max-width: 165px;"
    >
      <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:append-outer>
        <v-btn class="mt-n2" fab small>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>-->

    <div class="mx-3" />

    <v-switch
      v-if="false"
      label="Catálogos"
      inset
      :loading="$store.state.catalogos.loadingGenerarCatalogos"
      v-model="generarAutomaticos"
      :value="generarAutomaticos"
    >
    </v-switch>
    <v-btn min-width="0" text @click="goPanel">
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <span class="caption">{{ msjSinLeer }}</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <template v-for="(item, index) in mensajes">
          <app-bar-item
            :class="item.leido == false ? 'teal lighten-4' : 'grey lighten-4'"
            class="ma-0"
            :key="`item-${index}`"
          >
            <v-subheader
              v-if="item.header"
              :key="item.header"
              v-text="item.header"
            ></v-subheader>

            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-item v-else :key="item.titulo" @click>
              <v-list-item-icon>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="px-2"
                      color="danger"
                      small
                      min-width="0"
                      :loading="item.loading"
                      v-on="on"
                      @click="deleteMensaje(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar mensaje</span>
                </v-tooltip>
                <v-tooltip left v-if="!item.leido">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="px-2"
                      color="secondary"
                      small
                      min-width="0"
                      :loading="item.loading"
                      v-on="on"
                      @click="marcarLeido(item)"
                    >
                      <v-icon big>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Marcar como leído</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-html="item.titulo"></v-list-item-title>
                <v-list-item-subtitle v-html="item.msj"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon v-if="item.url" @click="download(item)"
                  >mdi-download</v-icon
                >
              </v-list-item-icon>
            </v-list-item>
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <!--<v-btn min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-phone</v-icon>Contactar
        </v-btn>-->
      </template>
      <v-list :tile="false" flat nav>
        <app-bar-item @click="goPanel">
          <v-list-item-title Telefono>Telefono</v-list-item-title>
        </app-bar-item>
        <v-divider class="mb-2 mt-2" />
        <app-bar-item @click="goPanel">
          <v-list-item-title Telefono>Whatsapp</v-list-item-title>
        </app-bar-item>
      </v-list>
      <!--<template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" flat nav>
        <template v-for="(p, i) in profile">
          <v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />

          <app-bar-item v-else :key="`item-${i}`" to="/">
            <v-list-item-title v-text="p.title" />
          </app-bar-item>
        </template>
      </v-list>-->
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";
import { goPanel } from "@/utils/router.js";
import { projectId } from "@/firebase";

// Utilities
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "DashboardCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    profile: [
      { title: "Profile" },
      { title: "Settings" },
      { divider: true },
      { title: "Log out" },
    ],
  }),
  computed: {
    ...mapState(["drawer"]),
    ...mapState({
      mensajes: (state) => state.auth.mensajes,
      negocioGest: (state) => state.app.negocioGest,
    }),
    generarAutomaticos: {
      get() {
        return this.$store.state.catalogos.generarAutomaticos;
      },
      set(v) {
        this.$store.commit("catalogos/setGenerarAutomaticos", v);
      },
    },
    ...mapGetters({
      msjSinLeer: "auth/mensajesSinLeer",
      esDesarrollo: "app/esDesarrollo",
    }),
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
    goPanel() {
      this.$router.push(goPanel());
    },
    marcarLeido(item) {
      item.loading = true;
      this.$store.dispatch("auth/marcarMensajeLeido", item.id).finally(() => {
        item.loading = false;
      });
    },
    deleteMensaje(item) {
      item.loading = true;
      this.$store.dispatch("auth/eliminarMensaje", item).finally(() => {
        item.loading = false;
      });
    },
    download(item) {
      this.marcarLeido(item);
      window.open(item.url, "_blank");
    },
  },
  mounted() {},
};
</script>
